import { render } from '@wordpress/element';

import './style.scss';
import Style from './Style';
import PDFEmbed from './PDFEmbed';

// PDF Embed
document.addEventListener('DOMContentLoaded', () => {
	const allPDFEmbed = document.querySelectorAll('.wp-block-peb-pdf-embed');
	allPDFEmbed.forEach(pdfEmbed => {
		const { attributes, pebAPIKey } = JSON.parse(pdfEmbed.dataset.props);

		pebAPIKey && attributes.file?.url && render(<>
			<Style attributes={attributes} clientId={attributes.cId} />

			<PDFEmbed attributes={attributes} clientId={attributes.cId} pebAPIKey={pebAPIKey} />
		</>, pdfEmbed);

		pdfEmbed?.removeAttribute('data-props');
	});
});